import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Outlet } from "react-router-dom";
import ClientHeader from "./ClientHeader";

const ClintLayout = () => {
	return (
		<Box>
			<ClientHeader />

			<Container maxWidth="lg" sx={{ mt: 2 }}>
				<Outlet />
			</Container>
		</Box>
	);
};

export default ClintLayout;
